import { useQuery } from '@tanstack/react-query';
import useInvalidateQueryOnUnmount from 'hooks/useInvalidateQueryOnUnmount';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import { ShareableLinkAnalyticsResponse } from 'models/ShareableLink';
import mixpanelService from 'services/mixpanelService';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import { getMixpanelErrorProps } from 'axiosUtils';
import { ErrorViewedProps } from 'models/MixpanelEvents';

const SHAREABLE_LINK_ANALYTICS_QUERY_KEY = 'shareable-link-analytics';

export default function useGetAnalytics(shareableLinkId: string) {
  const getMixpanelProps = useGetMixpanelProps();

  const query = useQuery<ShareableLinkAnalyticsResponse>({
    queryKey: [SHAREABLE_LINK_ANALYTICS_QUERY_KEY, shareableLinkId],
    queryFn: async () => {
      const { data } = await dataRoomApi.shareableLinks.getAnalytics(
        shareableLinkId,
      );

      return data;
    },
    onError: (error) =>
      mixpanelService.errorViewed(
        getMixpanelProps(getMixpanelErrorProps(error)) as ErrorViewedProps,
      ),
    enabled: !!shareableLinkId,
  });

  useInvalidateQueryOnUnmount(SHAREABLE_LINK_ANALYTICS_QUERY_KEY);

  return {
    ...query,
    analytics: query.data,
  };
}
